var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxSelectIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7206 9.16667L9.24692 11.6667L17.668 3.33333M16.8259 10V15.8333C16.8259 16.2754 16.6484 16.6993 16.3326 17.0118C16.0167 17.3244 15.5883 17.5 15.1417 17.5H3.35218C2.9055 17.5 2.47711 17.3244 2.16126 17.0118C1.84541 16.6993 1.66797 16.2754 1.66797 15.8333V4.16667C1.66797 3.72464 1.84541 3.30072 2.16126 2.98816C2.47711 2.67559 2.9055 2.5 3.35218 2.5H12.6153",
    stroke: "#344054",
    strokeWidth: 1.94994,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxSelectIcon);
export default __webpack_public_path__ + "static/media/checkbox-select-icon.1c21bea172be36e6a89702266f2a9be3.svg";
export { ForwardRef as ReactComponent };